<template>
  <div class="forget-password-dialog-container">
    <div class="main-container">
      <i class="el-icon-close" @click="close"></i>
      <h2 class="title">找回密码</h2>
      <div v-if="step===1" class="step1-container">
        <p>验证码将会发送至您的注册手机</p>
        <el-form :inline="false" :rules="forgetPasswordRules" :model="forgetPasswordForm"
                 ref="forgetPasswordForm">
          <el-form-item class="bottom-line-item" prop="phone">
            <el-input type="tel" placeholder="请输入您的手机号" maxlength="11"
                      v-model="forgetPasswordForm.phone"></el-input>
          </el-form-item>
        </el-form>
        <el-button class="next-button" type="primary" :loading="loading" @click="nextButtonClicked">
          下一步</el-button>
      </div>
      <div v-if="step===2" class="step2-container">
        <p>验证码已发送至您的手机</p>
        <el-form :inline="false" :rules="forgetPasswordRules" :model="forgetPasswordForm"
                 ref="forgetPasswordForm">
          <el-form-item class="bottom-line-item" prop="phone">
            <el-input type="tel" maxlength="11" v-model="forgetPasswordForm.phone" readonly>
            </el-input>
          </el-form-item>
          <el-form-item class="bottom-line-item" prop="code">
            <el-input type="text" placeholder="请输入 6 位短信验证码" maxlength="6"
                      v-model="forgetPasswordForm.code"></el-input>
            <el-button v-if="countdown<=0" class="countdown-button" type="text" :loading="loading"
                       @click="getCode">
              重新获取短信验证码
            </el-button>
            <el-button v-else class="countdown-button" type="text" disabled>{{countdown}} 秒后可重发
            </el-button>
          </el-form-item>
          <el-form-item class="bottom-line-item" prop="userName">
            <el-input type="text" placeholder="请输入用户名" v-model="forgetPasswordForm.userName">
            </el-input>
          </el-form-item>
          <p>新密码(由 8-20位大小字母、数字、特殊符号组成)</p>
          <el-form-item prop="newPassword">
            <el-input placeholder="请输入新密码" :type="passwordType" maxlength="30"
                      v-model="forgetPasswordForm.newPassword" clearable
                      :readonly="passwordReadonly" autocomplete='off'
                      @focus="passwordReadonly=false" @blur="passwordReadonly=false"></el-input>
            <i :class="['fontFamily',{'ryx-chakanmima':passwordType==='password'},{'ryx-yincangmima':passwordType==='text'},'passWordIcon']"
               @click="passwordTypeChange"></i>
            <div class="password-level-container">
              <div class="tile" :class="{red:passwordLevel===1}">低</div>
              <div class="tile" :class="{orange:passwordLevel===2||passwordLevel===3}">中</div>
              <div class="tile" :class="{green:passwordLevel===4}">高</div>
            </div>
          </el-form-item>
          <p>重复新密码</p>
          <el-form-item prop="confirmedPassword">
            <el-input placeholder="请重复输入新密码" :type="reusePasswordType" maxlength="30"
                      :readonly="confirmedPasswordReadonly"
                      v-model="forgetPasswordForm.confirmedPassword" autocomplete='off' clearable
                      @focus="confirmedPasswordReadonly=false"
                      @blur="confirmedPasswordReadonly=false"></el-input>
            <i :class="['fontFamily',{'ryx-chakanmima':reusePasswordType==='password'},{'ryx-yincangmima':reusePasswordType==='text'},'reusePassWordIcon']"
               @click="reusePasswordTypeChange"></i>
          </el-form-item>
        </el-form>
        <div class="password-container">

        </div>
        <div class="button-containers">
          <el-button class="save-button" :loading="loading" @click="saveButtonClicked">保存
          </el-button>
          <el-button class="cancel-button" @click="close">取消</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PasswordUtils, { publicKey } from '@/utils/password'
import JSEncrypt from 'jsencrypt/bin/jsencrypt'

export default {
  name: 'forgetPasswordDialog',
  data () {
    return {
      step: 1,
      loading: false,
      passwordReadonly: true,
      confirmedPasswordReadonly: true,
      countdown: 0,
      passwordType: 'password',
      reusePasswordType: 'password',
      userName: '',
      countdownIntervalId: null,
      forgetPasswordForm: {
        telUserName: '',
        phone: '',
        code: '',
        newPassword: '',
        confirmedPassword: '',
        userName: ''
      },
      forgetPasswordRules: {
        phone: [
          { required: true, message: '请输入您的手机号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!/^1\d{10}$/.test(value)) {
                callback(new Error('请输入11位有效手机号码'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (
                this.forgetPasswordForm.userName !== '' &&
                this.forgetPasswordForm.userName !== this.telUserName
              ) {
                callback(new Error('用户名不正确！'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入正确的短信验证码',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (this.wrongCodeList.indexOf(value) !== -1) {
                callback(new Error('请输入正确的短信验证码'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              if (value.indexOf(' ') > -1) {
                callback(new Error('验证码不能包含空格符'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        newPassword: [
          { required: true, message: '请输入您的新密码', trigger: 'blur' },
          { min: 8, max: 20, message: '密码长度需8-20位', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.passwordLevel < 4) {
                callback(
                  new Error('新密码必须由 8-20位大小字母、数字、特殊符号组成')
                )
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ],
        confirmedPassword: [
          { required: true, message: '请再次输入您的新密码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (
                this.forgetPasswordForm.newPassword !==
                this.forgetPasswordForm.confirmedPassword
              ) {
                callback(new Error('两次输入的密码不一致，请重新输入'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      wrongCodeList: []
    }
  },
  computed: {
    passwordLevel () {
      return PasswordUtils.testPasswordLevel(
        this.forgetPasswordForm.newPassword
      )
    }
  },
  methods: {
    reusePasswordTypeChange () {
      this.reusePasswordType =
        this.reusePasswordType === 'password' ? 'text' : 'password'
    },
    passwordTypeChange () {
      this.passwordType =
        this.passwordType === 'password' ? 'text' : 'password'
    },
    close () {
      this.$emit('close')
    },
    nextButtonClicked () {
      this.$refs.forgetPasswordForm.validate((valid) => {
        if (valid) {
          this.getCode()
        }
      })
    },
    saveButtonClicked () {
      this.$refs.forgetPasswordForm.validate((valid) => {
        if (valid) {
          this.modifyPassword()
        }
      })
    },
    async getCode () {
      this.loading = true
      this.wrongCodeList = []
      try {
        let { data } = await this.$https.axios({
          method: 'get',
          url: 'user/sendmodifyCode',
          params: { telphone: this.forgetPasswordForm.phone }
        })
        this.telUserName = data
        this.countdownIntervalId && clearInterval(this.countdownIntervalId)
        this.countdown = 60
        this.countdownIntervalId = setInterval(() => {
          --this.countdown
          if (this.countdown <= 0) {
            clearInterval(this.countdownIntervalId)
            this.countdownIntervalId = null
          }
        }, 1000)

        this.step = 2
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    async modifyPassword () {
      this.loading = true
      const jse = new JSEncrypt()
      jse.setPublicKey(publicKey) // 配置公钥
      let password = jse.encrypt(this.forgetPasswordForm.newPassword) // 加密密码
      const formData = {
        telphone: this.forgetPasswordForm.phone,
        code: this.forgetPasswordForm.code,
        newPassword: password
      }
      try {
        await this.$https.axios({
          codeHandleList: [{ code: 'WX4000', type: 1 }],
          method: 'post',
          url: 'user/updateloginPassword',
          data: formData
        })
        this.$message.success('密码已重置成功')
        this.close()
      } catch (e) {
        if (e.serverError && e.serverError.data.code === 'WX4000') {
          this.wrongCodeList.push(formData.code)
          this.$refs.forgetPasswordForm.validateField('code')
        }
        console.log(e)
      }
      this.loading = false
    }
  },
  beforeDestroy () {
    this.countdownIntervalId && clearInterval(this.countdownIntervalId)
  }
}
</script>
<style lang="less" scoped>
.forget-password-dialog-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  .reusePassWordIcon {
    position: absolute;
    right: 6px;
    cursor: pointer;
    top: -1px;
  }
  .passWordIcon {
    position: absolute;
    right: 106px;
    cursor: pointer;
    top: -1px;
  }
  > .main-container {
    position: relative;
    width: 500px;
    border-radius: 4px;
    padding: 40px 60px;
    background-color: #ffffff;
    > .el-icon-close {
      font-size: 18px;
      position: absolute;
      top: 16px;
      right: 16px;
      cursor: pointer;
    }
    > h2 {
      font-size: 22px;
    }
    > .step1-container {
      > .next-button {
        width: 100%;
        height: 48px;
        border-radius: 4px;
        border-width: 0;
        background-color: #78a6fe;
        color: #ffffff;
        text-align: center;
        font-size: 16px;
      }
    }
    > .step2-container {
      .countdown-button {
        position: absolute;
        height: 27px;
        top: 6px;
        right: 4px;
        padding: 0;
        line-height: 27px;
      }
      .password-level-container {
        display: flex;
        position: absolute;
        height: 27px;
        top: 6px;
        right: 4px;
        background-color: #f1f1f1;
        border-radius: 3px;
        overflow: hidden;
        > .tile {
          width: 33px;
          line-height: 27px;
          text-align: center;
        }
        .red {
          background-color: #ff4949;
          color: #fff;
        }
        .orange {
          background-color: #ff9b3a;
          color: #fff;
        }
        .green {
          background-color: #29c856;
          color: #fff;
        }
      }
      > .button-containers {
        text-align: center;
        margin-top: 36px;
        > button {
          display: inline-block;
          width: 96px;
          height: 42px;
          border: 1px solid;
          border-radius: 4px;
          text-align: center;
          font-size: 16px;
          &.save-button {
            margin-right: 16px;
            border-color: #78a6fe;
            background-color: #78a6fe;
            color: #ffffff;
          }
          &.cancel-button {
            border-color: #dadada;
            background-color: #ffffff;
            color: #78a6fe;
          }
        }
      }
    }
    > .step1-container,
    .step2-container {
      > p {
        margin-top: 4px;
        color: #999;
        font-size: 16px;
        line-height: 26px;
      }
      > .el-form {
        margin-top: 20px;
        > p {
          margin-bottom: 5px;
        }
        > .bottom-line-item {
          border-bottom: 1px solid #dddddd;
          &.is-error {
            border-bottom-color: #f56c6c;
          }
          /deep/ input {
            padding: 0;
            height: 32px;
            width: 100%;
            border: none;
            appearance: none;
            font-size: 16px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/forgetPasswordDialog.vue